import { CustomPart } from "@tm/models"

export const isTruncatedCustomPart = (part?: CustomPart) => {
    return !part?.articleNumber?.length || !part?.description?.length
}
